import React from 'react';
import {
  Snackbar as MuiSnackbar,
  IconButton,
  SnackbarProps,
} from '@mui/material';
import MuiAlert, { AlertColor } from '@mui/material/Alert';
import { useDispatch, useSelector } from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';
import { selectSnackbar, snackbarActions } from '../../redux/snackbarSlice';

const isValidSeverity = (severity: any): severity is AlertColor =>
  ['error', 'warning', 'info', 'success'].includes(severity);

const Alert = React.forwardRef<HTMLDivElement, any>(function Alert(props, ref) {
  return <MuiAlert elevation={6} variant="filled" ref={ref} {...props} />;
});

const Snackbar: React.FC = () => {
  const dispatch = useDispatch();
  const snackbar = useSelector(selectSnackbar);

  const handleClose: SnackbarProps['onClose'] = (event, reason) => {
    if (reason === 'clickaway') return;
    dispatch(snackbarActions.clearSnackbar());
  };

  const renderAction = (
    <IconButton
      size="small"
      aria-label="close"
      color="inherit"
      onClick={()=>handleClose}
    >
      <CloseIcon fontSize="small" />
    </IconButton>
  );

  return (
    <MuiSnackbar
      open={snackbar.open}
      autoHideDuration={5000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      {isValidSeverity(snackbar.severity) ? (
        <Alert
          onClose={handleClose}
          severity={snackbar.severity}
          action={renderAction}
        >
          {snackbar.message}
        </Alert>
      ) : (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {snackbar.message}
          {renderAction}
        </div>
      )}
    </MuiSnackbar>
  );
};

export default Snackbar;